import {SvgProps} from '../svgProps';
import {useSvg} from '../useSvg';

export const GlobeSvg = (props: SvgProps) => {
  const {fill, gradientMaybe, prefix} = useSvg(props);
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={props.className}
    >
      <g clipPath={`url(#${prefix('clip_path')})`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.4792 45.9483C20.7471 43.4294 17.9456 38.7729 16.3076 33.0002H3.91928C7.16248 40.2251 14.1903 45.3823 22.4792 45.9483ZM21.2758 40.0506C20.2217 38.0159 19.1816 35.6283 18.3912 33.0002L29.6088 33.0002C28.8184 35.6283 27.7783 38.0159 26.7242 40.0506C25.7483 41.9342 24.7728 43.4918 24 44.629C23.2272 43.4918 22.2517 41.9342 21.2758 40.0506ZM17 24C17 26.4328 17.3255 28.7859 17.8523 31.0002H30.1477C30.6745 28.7859 31 26.4328 31 24C31 21.5672 30.6745 19.2141 30.1477 16.9998H17.8523C17.3255 19.2141 17 21.5672 17 24ZM15.7997 16.9998C15.3038 19.2144 15 21.5649 15 24C15 26.4351 15.3038 28.7856 15.7997 31.0002L3.13713 31.0002C2.39961 28.8013 2 26.4473 2 24C2 21.5527 2.39961 19.1987 3.13713 16.9998L15.7997 16.9998ZM18.3912 14.9998L29.6088 14.9998C28.8184 12.3717 27.7783 9.98415 26.7242 7.94943C25.7483 6.0658 24.7728 4.50815 24 3.37102C23.2272 4.50815 22.2517 6.0658 21.2758 7.94943C20.2217 9.98415 19.1816 12.3717 18.3912 14.9998ZM32.2003 16.9998C32.6962 19.2144 33 21.5649 33 24C33 26.4351 32.6962 28.7856 32.2003 31.0002L44.8629 31.0002C45.6004 28.8013 46 26.4473 46 24C46 21.5527 45.6004 19.1987 44.8629 16.9998L32.2003 16.9998ZM44.0807 14.9998L31.6924 14.9998C30.0544 9.22712 27.2529 4.57058 25.5208 2.05174C33.8097 2.61767 40.8375 7.77486 44.0807 14.9998ZM16.3076 14.9998L3.91928 14.9998C7.16248 7.77486 14.1903 2.61767 22.4792 2.05174C20.7471 4.57058 17.9456 9.22712 16.3076 14.9998ZM25.5208 45.9483C27.2529 43.4294 30.0544 38.7729 31.6924 33.0002H44.0807C40.8375 40.2251 33.8097 45.3823 25.5208 45.9483ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id={prefix('clip_path')}>
          <rect width='48' height='48' fill={fill}/>
        </clipPath>
        {gradientMaybe}
      </defs>
    </svg>
  );
};
